"use client";

import { useState, useTransition } from "react";
import { loginAction } from "@/app/actions/auth";

export function LoginForm({ nextPath }: { nextPath: string }) {
  const [pending, startTransition] = useTransition();
  const [message, setMessage] = useState<string | null>(null);

  return (
    <form
      className="mt-6 space-y-4"
      onSubmit={(event) => {
        event.preventDefault();
        const form = new FormData(event.currentTarget);
        startTransition(async () => {
          const result = await loginAction({
            password: String(form.get("password") || ""),
            next: nextPath,
          });
          if (!result.ok) setMessage(result.message);
        });
      }}
    >
      <label className="block text-xs uppercase tracking-[0.16em] text-stone-500">
        Passwort
        <input
          name="password"
          type="password"
          autoComplete="current-password"
          className="mt-2 w-full rounded-2xl border border-white/10 bg-black/30 px-4 py-3 text-base text-stone-100 outline-none focus:border-amber-200/40"
        />
      </label>
      <button
        type="submit"
        disabled={pending}
        className="w-full rounded-full bg-amber-300 px-4 py-2 text-sm font-semibold text-zinc-950 disabled:opacity-70"
      >
        {pending ? "Prüfe…" : "Anmelden"}
      </button>
      {message ? <p className="text-sm text-rose-300">{message}</p> : null}
    </form>
  );
}
